export const handleWeChatJs = () => {
  try {
    const loadedJs = document.querySelectorAll('script');
    let isLoadedWeChatJs = false;
    loadedJs.forEach((sc) => {
      if (
        sc.src?.indexOf('https://res.wx.qq.com/open/js/jweixin') >= 0 ||
        sc.src?.indexOf('https://open.work.weixin.qq.com/wwopen/js/jwxwork') >= 0
      ) {
        isLoadedWeChatJs = true;
      }
    });
    if (!isLoadedWeChatJs && !window.wx) {
      document.write(`<scr` + `ipt src="https://res.wx.qq.com/open/js/jweixin-1.2.0.js"></scr` + `ipt>`);
      const ua = window?.navigator?.userAgent || '';
      // 特殊判断在 私有企业微信不加载jwxwork-1.0.0.js
      if (ua.toLowerCase().indexOf('wwlocal') === -1) {
        document.write(`<scr` + `ipt src="https://open.work.weixin.qq.com/wwopen/js/jwxwork-1.0.0.js"></scr` + `ipt>`);
      }
    }
  } catch (error) {
    console.error(error);
  }
};
